import { render, staticRenderFns } from "./Modifiers.vue?vue&type=template&id=34c60d9c&scoped=true&"
import script from "./Modifiers.vue?vue&type=script&lang=ts&"
export * from "./Modifiers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c60d9c",
  null
  
)

export default component.exports